var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('h2',[_vm._v("Checkout Cancelled")]),_c('p',{staticClass:"mt-3 mb-10"},[_vm._v(" Your checkout has been cancelled and no order has been placed. ")]),_c('v-btn',{attrs:{"color":"info"},on:{"click":function($event){return _vm.backToDashboard()}}},[_vm._v("Go back to dashboard")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }